import { invalidateOwner } from 'gear';

import { Xml } from '../util';
import { Process } from './process';

// Distress
//===============================================================================================

const Distress = Process.Distress = Process.extend({ typeName: 'DistressProcess',

  type: 'Distress',

  Properties: {
    scratchesLevel : { type: 'number'  , def: 0.5 , onChange: invalidateOwner, dropDef:true },
         rustLevel : { type: 'number'  , def: 0.5 , onChange: invalidateOwner, dropDef:true },
        foldsLevel : { type: 'number'  , def: 0.5 , onChange: invalidateOwner, dropDef:true },
    onOffThreshold : { type: 'number'  , def: 0.0 , onChange: invalidateOwner, dropDef:true }
  }
});
Xml.addFromBuild(Distress);



/** WEBPACK FOOTER **
 ** ./src/cdl/process/raster.js
 **/